// locales.js
// Trimmed to the keys used by carried components. defaultLocale is the
// fallback and intentionally holds empty strings; add new keys to BOTH blocks.
// Additional languages can be re-added as asset translations become available.
export const messages = {
    defaultLocale: {
      //App.vue
      assets: "",
      overview: "",
      inspectionMaintenance: "",
      assetData: "",
      switchTheme: "",
      //ActiveFiltersBar.vue
      activeFilters: "",
      clearAll: "",
      //Asset Overview KPIs
      registerCompleteness: "",
      registerCompletenessTooltip: "",
      commissionedTooltip: "",
      //Inspection & Maintenance KPIs
      lateOverdue: "",
      lateOverdueTooltip: "",
      due30Days: "",
      due31to60Days: "",
      due31to60Tooltip: "",
      noStatusHistoryWarning: "",
      //Asset Data KPIs
      totalInstallationCost: "",
      installationCost: "",
      installationCostTooltip: "",
      installationCostByCategory: "",
      lifecycleRecords: "",
      lifecycleRecordsTooltip: "",
      //new charts
      drawingBreakdown: "",
      categoryBreakdown: "",
      inspectionProgress: "",
      totalScope: "",
      planned: "",
      inspected: "",
      recordsCounted: "",
      plannedInspectedByDrawing: "",
      plannedInspectedByCategory: "",
      plannedInspectedByType: "",
      inspectionInterval: "",
      inspectionSchedule: "",
      outcome: "",
      outcomeDistribution: "",
      recordsByStatus: "",
      passRateTrendSubtitle: "",
      clickToFilterMissing: "",
      missing: "",
      uncategorised: "",
      today: "",
      day: "",
      week: "",
      month: "",
      //Gantt
      ganttName: "",
      ganttCreated: "",
      ganttInspected: "",
      expandAll: "",
      collapseAll: "",
      zoomIn: "",
      zoomOut: "",
      zoomToFit: "",
      loadMore: "",
      itemKind_installation: "",
      itemKind_commissioning: "",
      itemKind_inspection: "",
      itemKind_record: "",
      //grid
      createdBy: "",
      drawing: "",
      latestInspection: "",
      itemsCount: "",
      itemsClosed: "",
      //WelcomeDialog.vue
      welcomeMessage: "",
      loadDashboard: "",
      loaded: "",
      loadingPage: "",
      rowsLoaded: "",
      paginationInProgress: "",
      devModeActivated: "",
      copyQueryStringTitle: "",
      manualCopyInstruction: "",
      copy: "",
      close: "",
      copyFailed: "",
      // Table names
      table_assets: "",
      table_statusHistory: "",
      table_itemTemplates: "",
      table_categories: "",
      table_statusTemplates: "",
      table_drawings: "",
      table_locations: "",
      table_teams: "",
      table_teamUsers: "",
      table_users: "",
      table_currentUser: "",
      table_permissionRules: "",
      table_company: "",
      //DataLoadingProgress.vue
      dataLoading: {
        title: "",
        tablesLoaded: "",
        pending: "",
        error: "",
        continue: "",
        someTablesFailedToLoad: ""
      },
      //SettingsDialog.vue
      settings: {
        title: "",
        url: "",
        apiUrl: "",
        username: "",
        password: "",
        selectProject: "",
        close: "",
        submit: "",
        logout: ""
      },
      //ReportProgressFab.vue
      generateReport: "",
      reportReadyTitle: "",
      reportReadyMessage: "",
      done: "",
      //charts & grids
      showing: "",
      of: "",
      items: "",
      itemsPerPage: "",
      search: "",
      noData: "",
      total: "",
      status: "",
      count: "",
      durationDays: "",
      save: "",
      //AssetsPage.vue
      totalAssets: "",
      totalAssetsTooltip: "",
      locationsCovered: "",
      teamsAssigned: "",
      //AssetStatusBarCard.vue
      assetStatusBreakdown: "",
      //AssetTypeStackedBarChart.vue
      assetsByType: "",
      assetType: "",
      //grid headers / lookups
      location: "",
      assignedTeam: "",
      manufacturer: "",
      model: "",
      serialNumber: "",
      condition: "",
      warrantyExpiry: "",
      category: "",
      //Assets page KPIs & charts
      totalAssetValue: "",
      commissionedPercent: "",
      avgPassRate: "",
      assetsBySystem: "",
      assetSystem: "",
      ratingDistribution: "",
      notInspected: "",
      //Analysis page KPIs & charts
      installed: "",
      commissioned: "",
      inspectionsOverdue: "",
      neverInspected: "",
      installationProgress: "",
      responsibleParty: "",
      completeness: "",
      inspectionsDue: "",
      overdue: "",
      passRateTrend: "",
      valueBySystem: "",
      //AssetsGrid / MiniMap
      assetId: "",
      miniMap: "",
      details: "",
      photo: "",
      nextInspection: "",
      rating: "",
      passRate: "",
      priority: "",
      daysLeft: "",
      daysOverdue: "",
      qrCode: "",
      signature: "",
      commissionDate: "",
      installDate: "",
      assetValue: "",
      description: "",
      comments: "",
      viewDrawing: "",
      assetDataTable: ""
    },
    en: {
      //App.vue
      assets: "Assets",
      overview: "Asset Overview",
      inspectionMaintenance: "Inspection & Maintenance",
      assetData: "Asset Data",
      switchTheme: "Switch to {theme} Theme",
      //ActiveFiltersBar.vue
      activeFilters: "Filters:",
      clearAll: "Clear all",
      //Asset Overview KPIs
      registerCompleteness: "Asset Register Completeness",
      registerCompletenessTooltip: "Percentage of unique assets with every configured Asset identity field populated.",
      commissionedTooltip: "Percentage of unique assets whose current record has reached a completed status.",
      //Inspection & Maintenance KPIs
      lateOverdue: "Late / Overdue",
      lateOverdueTooltip: "Assets whose next inspection date has passed without a later inspection being recorded.",
      due30Days: "Due 30 Days",
      due31to60Days: "Due 31-60 Days",
      due31to60Tooltip: "Due between 31 and 60 days from today, so no asset is counted in both due periods.",
      noStatusHistoryWarning: "Status history is unavailable, so created dates fall back to the last-updated date.",
      //Asset Data KPIs
      totalInstallationCost: "Installation Cost",
      installationCost: "Installation Cost",
      installationCostTooltip: "Sum of the Installation Cost recorded against the assets in scope.",
      installationCostByCategory: "Installation Cost by Category",
      lifecycleRecords: "Lifecycle Records",
      lifecycleRecordsTooltip: "RDrive Items associated with the assets in scope, including installation, commissioning and every inspection.",
      //new charts
      drawingBreakdown: "Drawing Breakdown",
      categoryBreakdown: "Category Breakdown by Status",
      inspectionProgress: "Inspection Progress",
      totalScope: "Total Scope",
      planned: "Planned",
      inspected: "Inspected",
      recordsCounted: "Counts lifecycle records, not unique assets",
      plannedInspectedByDrawing: "Planned / Inspected by Drawing",
      plannedInspectedByCategory: "Planned / Inspected by Category",
      plannedInspectedByType: "Planned / Inspected by Type",
      inspectionInterval: "Inspection Interval",
      inspectionSchedule: "Inspection Schedule",
      outcome: "Outcome",
      outcomeDistribution: "Inspection / Asset Outcome",
      recordsByStatus: "Lifecycle records by status",
      passRateTrendSubtitle: "Average pass rate per inspection record",
      clickToFilterMissing: "Click a field to show the assets missing it",
      missing: "Missing",
      uncategorised: "Uncategorised",
      today: "Today",
      day: "Day",
      week: "Week",
      month: "Month",
      //Gantt
      ganttName: "Asset / Record",
      ganttCreated: "Created",
      ganttInspected: "Inspected",
      expandAll: "Expand all",
      collapseAll: "Collapse all",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      zoomToFit: "Zoom to fit",
      loadMore: "Load more...",
      itemKind_installation: "Installation",
      itemKind_commissioning: "Commissioning",
      itemKind_inspection: "Inspection",
      itemKind_record: "Record",
      //grid
      createdBy: "Created By",
      drawing: "Drawing",
      latestInspection: "Last Inspection",
      itemsCount: "{count} records",
      itemsClosed: "{closed} of {total} records closed",
      //WelcomeDialog.vue
      welcomeMessage: "Welcome to {projectName}",
      loadDashboard: "Load Dashboard",
      loaded: "loaded",
      loadingPage: "Loading page",
      rowsLoaded: "rows loaded",
      paginationInProgress: "Pagination in progress...",
      devModeActivated: "Dev mode activated",
      copyQueryStringTitle: "Copy Query String",
      manualCopyInstruction: "Select the text above and copy it manually.",
      copy: "Copy",
      close: "Close",
      copyFailed: "Failed to copy to clipboard",
      // Table names
      table_assets: "Assets",
      table_statusHistory: "Status History",
      table_itemTemplates: "Item Templates",
      table_categories: "Categories",
      table_statusTemplates: "Status Templates",
      table_drawings: "Drawings",
      table_locations: "Locations",
      table_teams: "Teams",
      table_teamUsers: "Team Users",
      table_users: "Users",
      table_currentUser: "Current User",
      table_permissionRules: "Permission Rules",
      table_company: "Company",
      //DataLoadingProgress.vue
      dataLoading: {
        title: "Loading Data",
        tablesLoaded: "tables loaded",
        pending: "Pending",
        error: "Error",
        continue: "Continue",
        someTablesFailedToLoad: "Some tables failed to load"
      },
      //SettingsDialog.vue
      settings: {
        title: "Settings",
        url: "URL",
        apiUrl: "API URL",
        username: "Username",
        password: "Password",
        selectProject: "Select Project",
        close: "Close",
        submit: "Submit",
        logout: "Logout"
      },
      //ReportProgressFab.vue
      generateReport: "Generate Report",
      reportReadyTitle: "Report ready",
      reportReadyMessage: "Your report has been generated and downloaded.",
      done: "Done",
      //charts & grids
      showing: "Showing",
      of: "of",
      items: "items",
      itemsPerPage: "Items per page",
      search: "Search",
      noData: "No data available",
      total: "Total",
      status: "Status",
      count: "Count",
      durationDays: "Duration (Days)",
      save: "Save",
      //AssetsPage.vue
      totalAssets: "Total Assets",
      totalAssetsTooltip: "Total number of assets matching the current filters.",
      locationsCovered: "Locations Covered",
      teamsAssigned: "Teams Assigned",
      //AssetStatusBarCard.vue
      assetStatusBreakdown: "Asset Status Breakdown",
      //AssetTypeStackedBarChart.vue
      assetsByType: "Assets by Type",
      assetType: "Asset Type",
      //grid headers / lookups
      location: "Location",
      assignedTeam: "Assigned Team",
      manufacturer: "Manufacturer",
      model: "Model",
      serialNumber: "Serial Number",
      condition: "Condition",
      warrantyExpiry: "Warranty Expiry",
      category: "Category",
      //Assets page KPIs & charts
      totalAssetValue: "Total Asset Value",
      commissionedPercent: "Commissioned",
      avgPassRate: "Avg Pass Rate",
      assetsBySystem: "Assets by System",
      assetSystem: "System",
      ratingDistribution: "Rating Distribution",
      notInspected: "Not Inspected",
      //Analysis page KPIs & charts
      installed: "Installed",
      commissioned: "Commissioned",
      inspectionsOverdue: "Inspections Overdue",
      neverInspected: "Never Inspected",
      installationProgress: "Installation & Commissioning Progress",
      responsibleParty: "Responsible Party",
      completeness: "Asset Data Completeness",
      inspectionsDue: "Inspections Due (Next 12 Months)",
      overdue: "Overdue",
      passRateTrend: "Pass Rate Trend",
      valueBySystem: "Asset Value by System",
      //AssetsGrid / MiniMap
      assetId: "Asset ID",
      miniMap: "Mini Map",
      details: "Details",
      photo: "Photo",
      nextInspection: "Next Inspection",
      rating: "Rating",
      passRate: "Pass Rate",
      priority: "Priority",
      daysLeft: "{days} days left",
      daysOverdue: "{days} days overdue",
      qrCode: "QR Code",
      signature: "Signature",
      commissionDate: "Commission Date",
      installDate: "Install Date",
      assetValue: "Asset Value",
      description: "Description",
      comments: "Comments",
      viewDrawing: "View Drawing",
      assetDataTable: "Asset Data Table"
    },
};
